import { html } from "lit";
var icon_download_default = () => html` <svg stroke-fill viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <path d="M16 6v15.27" />
      <path d="m10.4 15.55 5.6 5.72 5.6-5.72" />
      <path d="M30 21.27v1.91C30 25.3 28.33 27 26.27 27H5.73A3.78 3.78 0 0 1 2 23.18v-1.9" />
    </g>
  </svg>`;
export {
  icon_download_default as default
};
//# sourceMappingURL=icon-download.js.map
